import jsdk from '../../jsdk';
//import from '../../form/reducer';
require('../../form/reducer');
import modalRequire from '../../dialog';
import React from 'react';
import ReactDOM from 'react-dom';
import { EventEmitter } from 'events';
import t from 'tcomb';
import merge from 'lodash/object/merge';
import micromd from '../../micromd';
import UUID from '../domain/UUID';
import toUrl from '../domain/toUrl';
import get_bundle from '../domain/get_bundle';
import buildHeightNotifier from '../domain/buildHeightNotifier';
import User from '../domain/User';
import Product from '../domain/Product';
import Lattice from '../domain/Lattice';
import Behaviour from '../domain/Behaviour';
import TripGoal from '../domain/TripGoal';
import Authorization from '../domain/Authorization';
import Behaviour_Response from '../domain/Behaviour_Response';
import Behaviour_Needed from '../domain/Behaviour_Needed';
import Behaviour_Ok from '../domain/Behaviour_Ok';
import Behaviour_Ko from '../domain/Behaviour_Ko';
import Captcha from '../domain/Captcha';
import Reducer from '../domain/Reducer';
import Anonymous from '../domain/Anonymous';
import Registered from '../domain/Registered';
import Verified from '../domain/Verified';
import Locale from '../domain/Locale';
import load_districts from '../domain/load_districts';
import getMadaiURL from '../domain/getMadaiURL';
import target from '../domain/target';
import social_target from '../domain/social_target';
import setPurlCookies from '../domain/setPurlCookies';
import setSessionIdCookies from '../domain/setSessionIdCookies';
import countries from '../domain/countries';
import cancel_target from '../domain/cancel_target';
import Share_Purchase from '../domain/SharePurchase';
import Order from '../domain/Order';
import Datetime from '../domain/Datetime';
import attach_server from '../domain/attach_server';
import Server from '../domain/Server';
import GoogleAnalytics from '../domain/google_analytics';
import isModal from '../domain/isModal';
import setBackground from '../util/setBackground';
import doShare from '../util/doShare';
import createCallback from '../../createCallback';
import template  from 'lodash/string/template';
import ConsoleMessage from '../components/ConsoleMessage';
import Message from '../components/Message';
import Share from '../components/Share';
import Alert from '../components/Alert';
import Confirm from '../components/Confirm';
import MarkdownComponent from '../components/MarkdownComponent';
import HTMLComponent from '../components/HTMLComponent';
import Cookies from 'cookies-js';
import ProductView  from './route/Product';
import ProductWidgetView  from './route/widget/Product';
import Register from './route/Register';
import Login from './route/Login';
import RcsPrivacy from './route/RcsPrivacy';
import ChangePassword from './route/ChangePassword';
import Purchases from './route/Purchases';
import Account from './route/Account';
import ResendPassword from './route/ResendPassword';
import NoCookies from './route/NoCookies';
import RequestPin from './route/RequestPin';
import InsertPin from './route/InsertPin';
import Verify from './route/Verify';
import ProductNotAvailable from './route/ProductNotAvailable';
import ItemSold from './route/ItemSold';
import WidgetItemSold from './route/widget/ItemSold';
import ChangeLattice from './route/ChangeLattice';
import ApproveOrderError from './route/ApproveOrderError';
import Purchase from './route/Purchase';
import BuildOrder from './route/BuildOrder';
import ReducerView from './route/Reducer';
import ReducerWidgetView from './route/widget/Reducer';
import ApproveOrder from './route/ApproveOrder';
import CaptchaView from './route/Captcha';
import CaptchaWidgetView from './route/widget/Captcha';
import UnexpectedError from './route/UnexpectedError';
import parseQuerystring from '../../parseQuerystring';

import jsdkTemplate from '../jsdkTemplate';
t.form.Form.templates = jsdkTemplate;

const Trip = t.struct({
  goal: TripGoal,
  authorization: Authorization,
  reducer_id: t.maybe(UUID),
  lattice_id: t.maybe(UUID),
  timestamp: Datetime,
  old_price: t.maybe(t.Number)
}, 'Trip');

Trip.LOCAL_STORAGE_KEY = "Trip";
Trip.DURATION_MIN = 10;
Trip.DURATION_MILLIS = Trip.DURATION_MIN * 60 * 1000;

Trip.create = function (args) {
  args = merge(args, {timestamp: new Date().getTime()});
  const trip = new Trip(args);
  Trip.save(trip);
  return trip;
};

Trip.save = function (trip) {
  sessionStorage.setItem(Trip.LOCAL_STORAGE_KEY, JSON.stringify(trip));
};

Trip.remove = function () {
  sessionStorage.removeItem(Trip.LOCAL_STORAGE_KEY);
};

Trip.get = function () {
  const objTrip = sessionStorage.getItem(Trip.LOCAL_STORAGE_KEY);
  if (objTrip) {
    const trip = new Trip(JSON.parse(objTrip));
    if (trip.isValid()) {
      return trip;
    } else {
      Trip.remove();
      return null;
    }
  }
  return null;
};

Trip.prototype.isValid = function () {
  const now = new Date().getTime();
  return now < (this.timestamp + Trip.DURATION_MILLIS);
};

Trip.prototype.next = function (user, locale) {
  switch(this.goal) {
    case 'BuildOrderRoute':
      if (Anonymous.is(user)) {
        return new RegisterRoute(get_bundle(locale).landing.before_buy);
      }
      else if ( Registered.is(user) && this.authorization === 'verified') {
        return new RequestPinRoute();
      }
      return new BuildOrderRoute();
    case 'ReducerRoute':
      if (Anonymous.is(user) && this.authorization !== 'anonymous') {
        return new RegisterRoute(get_bundle(locale).landing.before_reduce);
      }
      else if (Registered.is(user) && this.authorization === 'verified') {
        return new RequestPinRoute(null);
      }
      else {
        return new ReducerRoute(this.lattice_id, this.reducer_id, this.old_price);
      }
  }
};

const Widget = jsdk.Widget;

// FIXME
jsdk.Message.prototype.bundle = function(locale) {
  return get_bundle(locale).template_message;
};

function getInitialRoute(err, product, user, locale, behaviour) {
  if (err) {
    t.assert(t.maybe(t.Str).is(err));
    return new LoginRoute(<Alert type='error'>{err}></Alert>);
  }
  else {
    if (product.is_available()) {
      const trip = Trip.get();
      if (trip) {
        return trip.next(user, locale);
      } else {
        // SOLO PER RCS
        if (product.locale.toJSON() === 'it_IT' && user.rcs_privacy_needed) {
          return new RcsPrivacyRoute();
        }
        else {
          // se c'è un behavior nella bootstrap (quindi, si assume che ci sia reducer=true) navigo sul reducer
          if (behaviour) {
            return new ReducerRoute(behaviour.lattice_id, behaviour.reducer_id);
          } else  {
            // se non c'è un behavior nella bootstrap navigo sulla product
            return new ProductRoute(null, null, true);
          }

        }
      }
    }
    else {
      return new ProductNotAvailableRoute();
    }
  }
}

const doAcceptCookies = () => {
  Cookies.set('accept_cookies', true, {
    path: '/'
  });
  document.getElementById('cookies_disclaimer').style.display = 'none';
};


const on_start = function() {
  // imposta il background del body se c'è una sponsorizzazione

  if (this.lattice) {
    setBackground(this.lattice.sponsor);
  }

  // comunica con il container quando l'applicazione è ospitata in una modale
  // e se il container supporta l'api post
  this.height_notifier = buildHeightNotifier(this);
  document.getElementsByTagName('body')[0].click = this.height_notifier;
  // polling per essere sicuro che la finestra si ridimensioni se contiene
  // delle immagini pesanti da caricare
  setInterval(this.height_notifier, 500);
};

export default class App extends EventEmitter {

  addLike(id){
    Reducer.add_like(id);
  }

  removeLike(id){
    Reducer.remove_like(id);
  }

  addGplus(id){
    Reducer.add_gplus(id);
  }

  removeGplus(id){
    Reducer.remove_gplus(id);
  }

  resolveCaptcha() {
    const route = this.route;
    // lattice_fake aggiunto per non cambiare l'endopoint del captcha.
    // Abbiamo aggiunto il captcha agli anomini per evitare che il bot lanciato da dos possa inserire milioni di righe nella "discount log"
    if ( route.lattice_id === 'bd69ee00-2703-11e6-bdf4-0800200c9a66' ) {
        this.transact(new ProductRoute());
    } else {
      this.transact(new ReducerRoute(route.lattice_id, route.reducer_id));
    }
  }

  Share_Purchase(){
    return Share_Purchase;
  }

  static go(mountNode, options) {
    setPurlCookies();
    setSessionIdCookies();
    const server = new Server(options.api_url);
    attach_server(server);
    options.locale = Locale.of(options.locale);
    if (options.user && options.user.com_locale) {
      options.user.com_locale = Locale.of(options.user.com_locale);
    }
    options.user = User(options.user);

    options.product = Product.of(options.product);
    Cookies.set('product_id', options.product.id, {
        path: '/'
      });
    options.lattice = options.lattice ? Lattice.of(options.lattice) : null;
    options.route = getInitialRoute(options.err, options.product, options.user, options.locale, options.behaviour);

    // devo nascondere il link al catalogo?
    const params = parseQuerystring(location.search);
    if (params.is_catalog_hidden === 'true') {
      options.lattice_url = null;
    }

    const app = new App(mountNode, server, options);

    // # monitoraggio
    const googleAnalytics = new GoogleAnalytics();


    function getPageview(name, args) {
      args = args || {};
      let lattice_id = app.lattice ? app.lattice.id : null;
      if (app.route.name === 'reducer') {
        lattice_id = app.route.lattice_id;
      }

      const url = toUrl(`product/${name}`, t.mixin({
        locale: app.locale.toJSON(),
        lattice_id,
        is_modal: isModal(),
        is_widget: app.is_widget,
        profile: Anonymous.is(app.user) ? 'anonymous' : Registered.is(app.user) ? 'registered' : 'verified',
        qs: location.search,
        reducer_id: app.route.name === 'reducer' ? app.route.reducer_id : null,
        session_id: Cookies.get('session-id'),
        now: new Date().getTime()
      }, args, true));
      return url;
    }

    // emitted when route changes
    app.on('route:change', function(route) {
      googleAnalytics.track_pageview(getPageview(route.name));
    });


    // completamento di un reducer diviso per skip e ok
    app.on('do_reduce', function(args) {
      var behaviour = args[0];
      var behaviour_ok = args[1];
      if (behaviour) {
        googleAnalytics.track_pageview(getPageview(behaviour.value ? 'reducer_ok' : 'reducer_skip', {
          reducer_id: behaviour.reducer_id
        }));
      }
      if (behaviour_ok.lead_url) {
        var url = behaviour_ok.lead_url + '?date=' + new Date().getTime();
        $('<img/>').attr('src', url).css('display', 'none').appendTo('body');
      }
    });

    // registrazione avvenuta con successo
    app.on('do_register', function() {
      googleAnalytics.track_pageview(getPageview('do_register'));
    });

    // acquisto di un prodotto
    app.on('do_approve_order', function(args) {
      var product_id = args[0];
      // iframe per tracciare acquisto del prodotto '522f43c4-d377-434c-b70c-da06183a6f6d' di RCS - corriere versione digitale
      // e del prodotto '69261ff0-01b0-4bac-ac98-dc70d31f2c2a' gazzetta
      if (process.env.NODE_ENV === 'production') {
        var RCS_product_ids = ['e62c7256-74dd-40f4-a1b9-a2990afccdc8'];
        if (RCS_product_ids.indexOf(product_id) !== -1) {
          $('<iframe src="https://launch1.co/serve?action=install&site_event_id=932902918&advertiser_id=9050" scrolling="no" frameborder="0" width="1" height="1"></iframe>').css('display', 'none').appendTo('body');
          $('<img height="1" width="1" alt="" style="display:none" src="https://www.facebook.com/offsite_event.php?id=6014435267752&value=0.00&currency=EUR" />').appendTo('body');
        }
      }
      googleAnalytics.track_pageview(getPageview('do_approve_order'));
    });

    // click sui share
    app.on('go_share', function(args) {
      var type = args[0];
      googleAnalytics.track_pageview(getPageview('go_share', {
        type: type
      }));
    });

    // click login facebook e google
    app.on('go_social_login', function(args) {
      var type = args[0];
      googleAnalytics.track_pageview(getPageview('go_social_login', {
        type: type
      }));
    });

    // verifica avvenuta con successo
    app.on('do_verify', function() {
      googleAnalytics.track_pageview(getPageview('do_verify'));
    });

    // messaggio good fellow
    // messaggio min price
    // messaggio sold out
    // messaggio expired
    // messaggi del registered
    app.on('message', function(args) {
      var type = args[0];
      googleAnalytics.track_pageview(getPageview('message', {
        type: type
      }));
    });

    app.on('do_share_purchase', function(type) {
      googleAnalytics.track_pageview(getPageview('do_share_purchase', {
        type: type
      }));
    });

    app.transact(options.route);

    on_start.bind(app)();

    return app;
  };


  constructor(mountNode, server, options) {
    super();
    t.assert(t.Str.is(options.api_url));
    t.assert(t.Str.is(options.lib_url));
    t.assert(t.Str.is(options.social_url));
    t.assert(t.maybe(t.Str).is(options.lattice_url));
    t.assert(t.Str.is(options.like_url));
    t.assert(t.Str.is(options.gplus_url));
    t.assert(Locale.is(options.locale));
    t.assert(User.is(options.user));
    t.assert(t.Obj.is(options.route));
    t.assert(Product.is(options.product));
    t.assert(t.maybe(Lattice).is(options.lattice));
    t.assert(t.Bool.is(options.is_corp));
    t.assert(t.Str.is(options.share_purchase_url));
    t.assert(t.maybe(t.Str).is(options.lattices_url));
    t.assert(t.Str.is(options.captcha_url));
    t.assert(t.Bool.is(options.is_widget));

    //cache dei reticoli
    options.lattices = {};

    jsdk.mixin(this, options);
    this.mountNode = mountNode;
    this.server = server;
    this.height_notifier = buildHeightNotifier(this);
  };

  stop() {
    if (this.widget instanceof Widget) {
      this.widget.stop();
      this.widget = null;
    }
    else {
      ReactDOM.unmountComponentAtNode(this.mountNode);
    }
  }

  scroll(route) {

    const isProductRouteAfterReducerRoute = () => {
      return (route.name === 'product' && route.old_price !== undefined && !this.is_widget);
    };

    if (isProductRouteAfterReducerRoute()) {
      this.scrollToConsoleTop();
    } else {
      this.scrollToTop();
    }
  }

  scrollToConsoleTop() {
    window.scrollTo(0, $('#console').offset().top - 10);
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }


  transact(route) {
    this.stop();
    this.route = route;
    route.to_widget(this, (widget) => {
      if (React.isValidElement(widget)) {
        this.mountNode = document.getElementById('app');
        ReactDOM.render(widget, this.mountNode);
      }
      else {
        this.mountNode.innerHTML = widget.to_html();
        widget.start();
        this.widget = widget;
      }
      this.emit('route:change', route);
      this.height_notifier();
      this.scroll(route);
    });
  }

  go_unexpected_err(err) {
    this.transact(new UnexpectedErrorRoute(err));
  }


  getThemeBtnColor() {
    return this.lattice ? this.lattice.theme_btn_color : null;
  }

  getThemeBgColor() {
    return this.lattice ? this.lattice.theme_bg_color : null;
  }

  getThemeBtnFontColor() {
    return this.lattice ? this.lattice.theme_btn_font_color : null;
  }

  getThemeBgFontColor() {
    return this.lattice ? this.lattice.theme_bg_font_color : null;
  }

  getBgSponsorColor() {
    if (this.lattice && this.lattice.sponsor && this.lattice.sponsor.bg_color) {
      return this.lattice.sponsor.bg_color;
    } else {
      return this.getThemeBtnColor();
    }
  }

  // Siccome i reticoli possono essere piuttosto corposi, implemento una
  // cache dei reticoli per id e locale in modo che una volta caricati
  // non siano richiesti una seconda volta via HTTP

  load_lattice(lattice_id, callback) {
    t.assert(UUID.is(lattice_id));
    t.assert(t.Func.is(callback));
    const app = this;
    if (app.lattices[lattice_id]) {
      callback(app.lattices[lattice_id]);
    }
    else {
      const errorHandler = (err) => {
        app.go_unexpected_err(err);
      };
      const successHandler = (lattice) => {
        app.lattices[lattice.id] = lattice;
        callback(lattice);
      };
      Lattice.load(lattice_id, createCallback(successHandler, errorHandler));
    }
  };


  // Questo è il singolo punto in cui il flusso passa quando si attua una
  // riduzione. Viene chiamato sia sul check, nel qual caso behaviour sarà
  // null, sia quando il consumer completa un reducer.
  // Il Server può rispondere in modo positivo, nel qual caso manderà un
  // aggiornamento del runtime del prodotto corrente, oppure con la richiesta
  // di completare un certo reducer di un certo reticolo
  reduce(behaviour, _old_price) {
    t.assert(t.maybe(Behaviour).is(behaviour));
    const app = this;
    const locale = app.locale;
    //const old_price = app.product.runtime.price;
    const errorHandler = (err) => {
      if (err) {
        switch (err.name) {
          case 'access denied':
            app.go_expired_session(locale);
            break;
          case 'invalid feedback':
            var error_message = locale.language_bundle().validation.any;
            $('#' + err.response_error.feedback_id + '_error').html(error_message);
            //$('#' + err.response_error.component_id).focus();
            break;
          default:
            app.go_unexpected_err(err);
        }
      }
    };
    const successHandler = (res) => {
      t.assert(Behaviour_Response.is(res));

      if (Behaviour_Needed.is(res)) {

        //
        // il server vuole un nuovo reducer per poter ridurre!
        //
        // nel caso questo reducer appartenga ad un reticolo
        // diverso da quello corrente passo dalla change_lattice
        // (questa riga non ha piu senso nella versione open) ma solo se l'utente non è un Registered in modo da non frammentargli l'esperienza utente

        // se il reducer_id è un reticolo che ha una componente con una email mappata e se l'utente è registered, devo fare una redirect sulla RegisterRoute

        const lattice_id = res.lattice_id;
        const reducer_id = res.reducer_id;

        const do_show_change_lattice = app.lattice &&
          app.lattice.id !== lattice_id &&
          //!Registered.is(app.user) &&  commentato per la nuova versione
          !app.is_corp;

        if (do_show_change_lattice) {
          app.transact(new ChangeLatticeRoute(lattice_id, reducer_id));
          app.lattice = null;
          setBackground(null);
        }
        else {
          //app.transact(new ReducerRoute(lattice_id, reducer_id));
          app.load_lattice(lattice_id, function(lattice) {
            t.assert(Lattice.is(lattice));
            const reducer = jsdk.find(lattice.reducers, reducer_id);

            const route = Trip.create({
              goal: "ReducerRoute",
              authorization: reducer.authorization,
              reducer_id: reducer_id,
              lattice_id: lattice_id,
              old_price: _old_price
            }).next(app.user, locale);

            app.transact(route);

          });
        }

      }
      else if (Behaviour_Ok.is(res)) {
        //
        // riduzione avvenuta con successo !
        //
        //
        // per tutte le tipologia di utenti: controllo che non ci sia stata una item sold
        // guardando se i deal sono cambiati e nel caso lo mando sull'apposita interfaccia
        // ma non se il prodotto è andato in sold out
        //
        // in ogni caso rinnovo il prodotto con il nuovo runtime

        app.emit('do_reduce', [behaviour, res]);
        const old_price = app.product.runtime.price;
        const product = app.product.replace_runtime(res.runtime);
        let state = null;

        // c'è stata una item sold se non c'erano deals e adesso ci sono
        // oppure se l'ultimo deal ha come delta un intero minore
        const prev_len = app.product.runtime.lasts.length;
        const is_item_sold = (prev_len === 0 && product.runtime.lasts.length > 0) ||
          (prev_len > 0 && app.product.runtime.lasts[0].tick < product.runtime.lasts[0].tick);
        const is_sold_out = product.runtime.is_sold_out;



        if (is_item_sold && !is_sold_out) {
          state = new ItemSoldRoute();
        }
        else {
          let msg = null;
          if (res.is_good_fellow) {
            if (app.lattices_url) {
              const tmp = micromd(get_bundle(app.locale)['template_message']['product.goodfellow_more_lattices']);
              const _msg = jsdk.template(tmp, jsdk.template.mustache)({
                go_lattices: "<button  id=\"go_more_lattices\" onclick='location.href=\"" + app.lattices_url + "\"' style=\"background-color:" + app.getThemeBtnColor() + "\" \">" + get_bundle(locale).navigation.go_lattices + "</button>"
              });
              msg = (<ConsoleMessage><HTMLComponent>{_msg}</HTMLComponent></ConsoleMessage>);
              app.emit('message', ['good_fellow_more_lattices']);
              state = new ProductRoute(msg, old_price);
            }
            else {
              const getGoodFellowMessage = () => {
                if (app.is_widget) {
                  return get_bundle(app.locale)['template_message']['product.goodfellow.short'];
                }
                return get_bundle(app.locale)['template_message']['product.goodfellow'];
              };

              const getShare = () => {
                if (app.is_widget) {
                  return null;
                }
                return (
                  <div id='share_offer'>
                    <Share doShowShare={true} doShare={doShare(app)} />
                  </div>
                );
              };

              msg = (
                <ConsoleMessage>
                  <MarkdownComponent>
                    {getGoodFellowMessage()}
                  </MarkdownComponent>
                  {getShare()}
                </ConsoleMessage>
              );
              app.emit('message', ['good_fellow']);
              state = new ProductRoute(msg, old_price);
            }
          }

          //app.reduce(null);

          //state = new ProductRoute(msg, old_price);
          //state = new ReducerRoute(res.lattice_id, res.reducer_id);
        }

        app.product = product;
        if (state) {
          app.transact(state);
        } else if (!app.is_widget) {
          const btnReducer = document.getElementById('do_reduce');
          btnReducer.disabled = true;
          //app.transact(new ReducerRoute(app.route.lattice_id, app.route.reducer_id));
          setTimeout(function(){ app.reduce(null, old_price); }, 1000);
        } else {
          app.transact(new ProductRoute(null, old_price));
        }
      }
      else if (Behaviour_Ko.is(res)){
        // reducer ko
        // fix per impedire l'ulitizzo di campagne diverse su più tab
        // commentata la riga sottostanta in data 31 maggio per evitare l'errore in console
        // modalRequire.Alert.go(locale, 500, micromd(get_bundle(locale).template_message.reducer_ko));
      }
      else if (Captcha.is(res)){
        // Captcha
        app.transact(new CaptchaRoute(res.lattice_id, res.reducer_id));
      }
    };
    const _callback = createCallback(successHandler, errorHandler);

    Reducer.do_reduce(app.product.id, behaviour, _callback, {
      product_id: app.product.id,
      behaviour: JSON.stringify(behaviour)
    });
  };


  // da chiamare quando si riceve una access denied da una chiamata alle api sotto autenticazione
  go_expired_session(locale) {
    this.user = User({
      profile: 'anonymous'
    });
    const bundle = get_bundle(locale).template_message;
    this.transact(new LoginRoute(<Alert type='error'>{bundle['expired_session']}</Alert>));
  };

  sponsor() {
    const app = this;
    return app.lattice ? app.lattice.sponsor : null;
  };

  widget() {
    const app = this;
    return app.lattice ? app.lattice.widget : null;
  };


  partners() {
    const app = this;
    return app.lattice ? app.lattice.partners : null;
  };

  getMiniSiteURL() {
    const location = window.location;
    const PRODUCT_URL = location.pathname;
    const params = parseQuerystring(location.search);
    let newParams = {};
    if (params.lattice) {
      newParams['lattice'] = params.lattice;
    }
    if (params.utm_campaign) {
      newParams['utm_campaign'] = params.utm_campaign;
    }
    if (params.utm_medium) {
      newParams['utm_medium'] = params.utm_medium + '_widget_exit';
    }
    if (params.utm_source) {
      newParams['utm_source'] = params.utm_source;
    }
    return location.origin + toUrl(PRODUCT_URL, newParams);
  }

  openMiniSite() {
    window.open(this.getMiniSiteURL());
  }

}


// perchè ciotta non vuole fare un controllo tra stringhe, facendo cosi, si crea un enum "YES", "NO", "".
function adapt_privacy_value(value) {
  t.assert(t.maybe(t.Str).is(value));
  var tmp = {
    "true": "YES",
    "false": "NO"
  };
  return tmp[value] ? tmp[value] : '';
}

// - account non esistente: invio email pwd
// - account attivo: invio email warning
// - account cancellato: invio email support
// - email non formalmente valida: errore su login
function do_register(app) {
  return function(email, privacy_rcs, privacy_other, privacy_tracking) {
    const errorHandler = (err) => {
      if (err) {
        switch (err.name) {
          case 'invalid emailAddress':
            const msg = template(get_bundle(app.locale)['template_message']['invalid emailAddress'])({
              email: email
            });
            app.transact(new LoginRoute(<Alert type='error'>{msg}</Alert>));
            break;
          default:
            app.go_unexpected_err(err);
        }
      }
    };
    const successHandler = () => {
      app.emit('do_register');
      const msg = template(get_bundle(app.locale)['template_message']['register.done'])({
          email: email
        });
      app.transact(new LoginRoute(<Message bgColor={app.getThemeBgColor()} fontColor={app.getThemeBgFontColor()}><MarkdownComponent>{msg}</MarkdownComponent></Message>));
    };
    const callback = createCallback(successHandler, errorHandler);
    app.user.do_register(email, app.locale, adapt_privacy_value(privacy_rcs), adapt_privacy_value(privacy_other), adapt_privacy_value(privacy_tracking), callback);
  };
}

const goChangePassword = (app) => {
  return function() {
    app.transact(new ChangePasswordRoute());
  };
};

const doLogout = (app) => {
  const errorHandler = (err) => {
    if (err) {
      app.go_unexpected_err(err);
    }
  };
  const successHandler = (user) => {
    app.user = user;
    app.transact(new RegisterRoute());
  };
  return function() {
    app.user.do_logout(createCallback(successHandler, errorHandler));
  };
};

const goPurchases = (app) =>  {
  return function() {
    app.transact(new PurchasesRoute());
  };
};

const goAccount = (app) => {
  return function() {
    load_districts(app.lib_url, app.user.country, function() {
      app.transact(new AccountRoute());
    });
  };
};

const goCatalog = (app) => {
  var qs = parseQuerystring(location.search);
  if (qs.is_catalog_hidden /* messo eventualmente dalla modale */ ) {
    return null;
  }
  else if (app.lattice_url) {
    return function() {
      if (Cookies.get("product_id")) {
        Cookies.expire('product_id')
      }
      location.href = app.lattice_url;
    };
  }
  else if (app.lattice && !!(app.lattice.is_white_label)) {
    return null;
  } else {
    return function() {
      location.href = getMadaiURL() //+ app.locale.country.toLowerCase();
    };
  }
};

const goLattices = (app) => {
  if (!app.lattices_url) {
    return null;
  }
  else {
    return function() {
      location.href = app.lattices_url;
    };
  }
};

const goProduct = (app) => {
  return function() {
    app.transact(new ProductRoute());
  };
};

function go_facebook(app) {
  const errorHandler = (err) => {
    if (err) {
      app.go_unexpected_err(err);
    }
  };
  const successHandler = (url) => {
    app.emit('go_social_login', ['facebook']);
    window.top.location.href = url;
  };
  const callback = createCallback(successHandler, errorHandler);
  return function() {
    app.user.load_facebook(social_target(app), app.locale, callback);
  };
}

function go_google(app) {
  const errorHandler = (err) => {
    if (err) {
      app.go_unexpected_err(err);
    }
  };
  const successHandler = (url) => {
    app.emit('go_social_login', ['google']);
    window.top.location.href = url;
  };
  const callback = createCallback(successHandler, errorHandler);
  return function() {
    app.user.load_google(social_target(app), app.locale, callback);
  };
}

function go_microsoft(app) {
  const errorHandler = (err) => {
    if (err) {
      app.go_unexpected_err(err);
    }
  };
  const successHandler = (url) => {
    app.emit('go_social_login', ['microsoft']);
    window.top.location.href = url;
  };
  const callback = createCallback(successHandler, errorHandler);
  return function() {
    app.user.load_microsoft(social_target(app), app.locale, callback);
  };
}

function go_twitter(app) {
  const errorHandler = (err) => {
    if (err) {
      app.go_unexpected_err(err);
    }
  };
  const successHandler = (url) => {
    app.emit('go_social_login', ['twitter']);
    window.top.location.href = url;
  };
  const callback = createCallback(successHandler, errorHandler);

  const getLatticeId = () => {
    return app.lattice ? app.lattice.id : null;
  };

  return function() {
    app.user.load_twitter(social_target(app), app.locale, getLatticeId(), callback);
  };
}

// ------
// routes
// ------

class UnexpectedErrorRoute {

  constructor(err) {
    this.name = 'unexpected_error';
    this.err = err;
  }

  to_widget(app, callback) {

    const doRefresh = () => {
      location.reload();
    };

    callback(<UnexpectedError
                sponsor={app.sponsor()}
                locale={app.locale}
                err={this.err}
                doAcceptCookies={doAcceptCookies}
                doRefresh={doRefresh} />
    );
  }
}

class ChangeLatticeRoute {

  constructor (lattice_id, reducer_id) {
    this.name = 'change_lattice';
    this.lattice_id = lattice_id;
    this.reducer_id = reducer_id;
  }

  to_widget(app, callback) {

    const locale = app.locale;
    const self = this;
    const goReducer = () => {
      app.transact(new ReducerRoute(self.lattice_id, self.reducer_id));
    };

    callback(<ChangeLattice
      locale={locale}
      product={app.product}
      sponsor={app.sponsor()}
      themeBgColor={app.getThemeBgColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      goReducer={goReducer}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  }
}

class ProductNotAvailableRoute {

  constructor() {
    this.name = 'product_not_available';
  }

  to_widget(app, callback) {
    const locale = app.locale;

    callback(<ProductNotAvailable
      locale={locale}
      product={app.product}
      sponsor={app.sponsor()}
      themeBgColor={app.getThemeBgColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      showLatticeUrl={app.lattice_url !== null}
      goCatalog={goCatalog(app)}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  };
}

class ProductRoute {

  constructor(message, old_price, showLucidTutorial) {
    this.name = 'product';
    this.message = message;
    this.old_price = old_price;
    this.showLucidTutorial = showLucidTutorial;
    const params = parseQuerystring(location.search);
    this.from = params.from;
    this.status = params.status;
  }

  to_widget(app, callback){
    const { locale, product, user, is_widget } = app;
    const is_sold_out = product.runtime.is_sold_out;
    const is_expired = product.is_expired();

    const doShowConsole = () => {
      return !is_sold_out && !is_expired;
    };

    const doShowShare = () => {
      return !is_sold_out && !is_expired && !is_widget;
    };

    const getConsoleMessage = () => {
      let message;
      const bundle = get_bundle(locale).template_message;
      if (is_sold_out) {
        app.emit('message', ['is_sold_out']);
        message = <ConsoleMessage><MarkdownComponent>{bundle['product.is_sold_out']}</MarkdownComponent></ConsoleMessage>;
      }
      else if (is_expired) {
        app.emit('message', ['is_expired']);
        message = <ConsoleMessage><MarkdownComponent>{bundle['product.is_expired']}</MarkdownComponent></ConsoleMessage>;
      }

      else if (product.runtime.price <= product.min_price) {
        app.emit('message', ['min_price']);
        message = <ConsoleMessage><MarkdownComponent>{bundle['product.min_price']}</MarkdownComponent></ConsoleMessage>;
      }
      else if (this.message) {
        message = this.message;
      }

      return message;
    };

    const getAdvBoxes = () => {
      return (app.lattice && app.lattice.adv_boxes) ? app.lattice.adv_boxes : [];
    };

    const doReduce = () => {
      app.reduce(null);
    };



    const goBuildOrder = () => {
      if  ( app.is_widget ) {
        return app.openMiniSite();
      }

      const route = Trip.create({
        goal: "BuildOrderRoute",
        authorization: product.authorization
      }).next(user, locale);

      app.transact(route);

    };

    const goPurchase = (purchase_id) => {
      app.transact(new PurchaseRoute(purchase_id));
    };

    const goLogin = () => {
      app.transact(new LoginRoute());
    };

    const showLucidTutorial = () => {
      if ( ['lucid', 'pollfish'].indexOf(app.route.from) !== -1 && app.route.showLucidTutorial) {
        return true
      } else {
        return false
      }
    };
    const statusLucidTutorial = () => {
      if (!showLucidTutorial()) {
        return null
      } 
      // ok-ko
      return app.route.status 
    };

    //pixel di atterraggio
    // iframe per tracciare atterraggio sui prodotti '77e18721-aac2-40ac-b2c6-0d3e4df93979', 'a3c09827-3665-4f8e-97d3-96d6fde945ed' di CartaSi
    if (process.env.NODE_ENV === 'production') {
      var CartaSi_product_ids = ['77e18721-aac2-40ac-b2c6-0d3e4df93979', 'a3c09827-3665-4f8e-97d3-96d6fde945ed'];
      if (CartaSi_product_ids.indexOf(product.id) !== -1) {
        $('<img src="https://track.adform.net/Serving/TrackPoint/?pm=572854&ADFPageName=Mysi&ADFdivider=|" width="1" height="1" alt="" />').appendTo('body');
      }
      var IBL_product_ids = ['a8d02ce8-d600-4d3e-9390-faf53ee0fa4c', 'd316d5dc-ce5b-41c6-a96b-db1314fa514f', '4f028a81-773b-416a-8c2a-b6b416308706', '1686c579-73b6-430b-90ee-9e87c5fdafae', 'c2847349-0dfe-4ea8-815c-317a3673b1b2', '16bb7c57-f970-4c86-bb2e-0240be16f59d'];
      if (IBL_product_ids.indexOf(product.id) !== -1) {
        $('<img src="https://track.adform.net/Serving/TrackPoint/?pm=64073&ADFPageName=Conversion%20page&ADFdivider=|" width="1" height="1" alt="" />').appendTo('body');
      }
    }

    if (app.is_widget) {
      callback(<ProductWidgetView
        locale={locale}
        product={product}
        message={getConsoleMessage()}
        oldPrice={app.route.old_price}
        doShowConsole={doShowConsole()}
        doReduce={doReduce}
        goBuildOrder={goBuildOrder}
        goPurchase={goPurchase}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        widget={app.widget()}
        miniSiteURL={app.getMiniSiteURL()} />);
    } else {
      callback(<ProductView
        locale={locale}
        product={product}
        user={user}
        sponsor={app.sponsor()}
        message={getConsoleMessage()}
        oldPrice={app.route.old_price}
        doShowConsole={doShowConsole()}
        doShowShare={doShowShare()}
        advBoxes={getAdvBoxes()}
        partners={app.partners()}
        doReduce={doReduce}
        doShare={doShare(app)}
        goBuildOrder={goBuildOrder}
        goPurchase={goPurchase}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        doAcceptCookies={doAcceptCookies}
        goLogin={goLogin}
        goAccount={goAccount(app)}
        goPurchases={goPurchases(app)}
        goChangePassword={goChangePassword(app)}
        doLogout={doLogout(app)}
        goCatalog={goCatalog(app)}
        goLattices={goLattices(app)}
        showLucidTutorial={showLucidTutorial()}
        statusLucidTutorial={statusLucidTutorial()} />
      );
    }
  }
}

class NoCookiesRoute {
  constructor() {
    this.name = 'no_cookies';
  }

  to_widget(app, callback) {
    callback(<NoCookies locale={app.locale} />);
  }
}

class ReducerRoute {
  constructor(lattice_id, reducer_id, old_price) {
    this.name = 'reducer';
    this.lattice_id = lattice_id;
    this.reducer_id = reducer_id;
    this.old_price = old_price;
  }

  to_widget(app, callback) {
    Trip.remove();
    const locale = app.locale;
    const lattice_id = this.lattice_id;
    const user = app.user;

    app.load_lattice(lattice_id, (lattice) => {
      t.assert(Lattice.is(lattice));
      load_districts(app.lib_url, user.country, () => {

        const do_reduce = (value) => {
          app.reduce(reducer.getReducerBehaviour(lattice_id, value));
        };

        const do_skip = () => {
          app.reduce(reducer.getSkipBehaviour(lattice_id));
        };

        const goBuildOrder = () => {
          if  ( app.is_widget ) {
            return app.openMiniSite();
          }

          const route = Trip.create({
            goal: "BuildOrderRoute",
            authorization: app.product.authorization
          }).next(user, locale);

          app.transact(route);

        };

        const goPurchase = (purchase_id) => {
          app.transact(new PurchaseRoute(purchase_id));
        };

        const reducer = jsdk.find(lattice.reducers, this.reducer_id);

        const context = {
          user,
          fields: User.to_fields(user, locale)
        };

        if (app.is_widget) {
          callback(
            <ReducerWidgetView
              locale={locale}
              sponsor={app.sponsor()}
              reducer={reducer}
              context={context}
              like_url={app.like_url}
              gplus_url={app.gplus_url}
              do_reduce={do_reduce}
              do_skip={do_skip}
              goPurchase={goPurchase}
              themeBgColor={app.getThemeBgColor()}
              themeBtnColor={app.getThemeBtnColor()}
              themeBgFontColor={app.getThemeBgFontColor()}
              themeBtnFontColor={app.getThemeBtnFontColor()}
              widget={app.widget()}
              miniSiteURL={app.getMiniSiteURL()}
          />);
        } else {
          callback(
            <ReducerView
              locale={locale}
              user={user}
              product={app.product}
              sponsor={app.sponsor()}
              reducer={reducer}
              context={context}
              like_url={app.like_url}
              gplus_url={app.gplus_url}
              go_product={goProduct(app)}
              do_reduce={do_reduce}
              do_skip={do_skip}
              goPurchase={goPurchase}
              themeBgColor={app.getThemeBgColor()}
              themeBtnColor={app.getThemeBtnColor()}
              themeBgFontColor={app.getThemeBgFontColor()}
              themeBtnFontColor={app.getThemeBtnFontColor()}
              goAccount={goAccount(app)}
              goPurchases={goPurchases(app)}
              goChangePassword={goChangePassword(app)}
              doLogout={doLogout(app)}
              doAcceptCookies={doAcceptCookies}
              partners={app.partners()}
              oldPrice={app.route.old_price}
              // message=
              goBuildOrder={goBuildOrder}
              // goPurchase=
              />

          );
        }
      });
    });
  }
}

class LoginRoute {

  constructor(message){
    this.name = 'login';
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;
    const bundle = get_bundle(locale)['template_message'];

    const goResendPassword = () => {
      app.transact(new ResendPasswordRoute());
    };

    const goRegister = () => {
      app.transact(new RegisterRoute());
    };

    const doLogin = (email, password) => {
      const errorHandler = (err) => {
        if (err) {
          switch (err.name) {
            case 'account deleted':
            case 'invalid emailAddress':
              const msg = template(bundle[err.message])({
                email: email
              });
              app.transact(new LoginRoute(<Alert type='error'>{msg}</Alert>));
              break;
            case 'access denied':
              app.transact(new LoginRoute(<Alert type='error'>{bundle['login.access denied']}</Alert>));
              break;
            default:
              app.go_unexpected_err(err);
          }
        }
      };

      const successHandler = (user) => {
        const errorHandlerLoadRuntime = (err) => {
          if (err) {
            app.go_unexpected_err(err);
          }
        };
        const successHandlerLoadRuntime = (product) => {
          app.user = user;
          app.product = product;

          const trip = Trip.get();
          if (trip) {
            app.transact(trip.next(user, locale));
          } else {
            // SOLO PER RCS
            if (product.locale.toJSON() === 'it_IT' && user.rcs_privacy_needed) {
              app.transact(new RcsPrivacyRoute());
            }
            else {
              app.transact(new ProductRoute());
            }
          }
        };
        app.product.load_runtime(createCallback(successHandlerLoadRuntime, errorHandlerLoadRuntime));
      };
      app.user.do_login(email, password, createCallback(successHandler, errorHandler));
    };

    callback(<Login
      locale={locale}
      message={this.message}
      sponsor={app.sponsor()}
      themeBgColor={app.getThemeBgColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      goRegister={goRegister}
      doAcceptCookies={doAcceptCookies}
      doLogin={doLogin}
      goResendPassword={goResendPassword}
      goProduct={goProduct(app)}
      goFacebook={go_facebook(app)}
      goGoogle={go_google(app)}
      goMicrosoft={go_microsoft(app)}
      goTwitter={go_twitter(app)}
      partners={app.partners()} />);
  }
}

class RegisterRoute {

  constructor(message) {
    this.name = 'register';
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;

    const hasThirdPartiesPrivacy = () => {
      return (app.lattice) ? app.lattice.has_third_parties_privacy : false;
    };

    const goLogin = () => {
      app.transact(new LoginRoute());
    };

    callback(<Register
      locale={locale}
      message={this.message}
      sponsor={app.sponsor()}
      themeBgColor={app.getThemeBgColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      goFacebook={go_facebook(app)}
      goGoogle={go_google(app)}
      goMicrosoft={go_microsoft(app)}
      goTwitter={go_twitter(app)}
      doRegister={do_register(app)}
      hasThirdPartiesPrivacy={hasThirdPartiesPrivacy()}
      goLogin={goLogin}
      goCatalog={goCatalog(app)}
      goProduct={goProduct(app)}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  }
}

class RcsPrivacyRoute {

  constructor() {
    this.name = 'rcs_privacy';
  }

  to_widget(app, callback) {
    const locale = app.locale;

    const doAcceptRcsPrivacy = () => {
      const errorHandler = (err) => {
        if (err) {
          app.go_unexpected_err(err);
        }
      };
      const successHandler = (user) => {
        app.user = user;
        app.transact(new ProductRoute());
      };
      app.user.do_accept_rcs_privacy(createCallback(successHandler, errorHandler));
    };

    callback(<RcsPrivacy
      locale={locale}
      themeBgColor={app.getThemeBgColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      sponsor={app.sponsor()}
      doAcceptRcsPrivacy={doAcceptRcsPrivacy}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  }
}

class ResendPasswordRoute {

  constructor(message) {
    this.name = 'resend_password';
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;
    const bundle = get_bundle(locale);

    const doResendPassword = (email) => {
      const errorHandler = (err) => {
        if (err) {
          switch (err.name) {
            case 'invalid emailAddress':
              const msg = template(bundle['template_message']['invalid emailAddress'])({
                email: email
              });
              app.transact(new ResendPasswordRoute(<Alert type='error'>{msg}</Alert>));
              break;
            default:
              app.go_unexpected_err(err);
          }
        }
        };
        const successHandler = () => {
          const msg = template(bundle['template_message']['resend_password.done'])({
            email: email
          });
          app.transact(new LoginRoute(<Message bgColor={app.getThemeBgColor()} fontColor={app.getThemeBgFontColor()}><MarkdownComponent>{msg}</MarkdownComponent></Message>));
        };
        app.user.do_resend_password(email, createCallback(successHandler, errorHandler));
    };

    const goLogin = () => {
      app.transact(new LoginRoute());
    };

    callback(<ResendPassword
      locale={locale}
      sponsor={app.sponsor()}
      message={this.message}
      themeBgColor={app.getThemeBgColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      doResendPassword={doResendPassword}
      goLogin={goLogin}
      goProduct={goProduct(app)}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  }
}

class AccountRoute {

  constructor(message) {
    this.name = 'account';
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;
    const user = app.user;

    load_districts(app.lib_url, user.country, (districts) => {

        const loadDistricts = (country, callback) => {
          load_districts(app.lib_url, country, callback);
        };

        const doUpdateAccount = (name, surname, gender, birth_date, country, district, zip, com_locale) => {
          const errorHandler = (err) => {
            if (err) {
              switch (err.name) {
                case 'access denied':
                  app.go_expired_session(app.locale);
                  break;
                default:
                  app.go_unexpected_err(err);
              }
            }
          };
          const successHandler = (user) => {
            load_districts(app.lib_url, country, () => {
              app.user = user;
              const bundle = get_bundle(locale);
              app.transact(new AccountRoute(<Alert type='success'>{bundle['template_message']['account.done']}</Alert>));
            });
          };
          const _callback = createCallback(successHandler, errorHandler);
          app.user.do_update_account(name, surname, gender, birth_date, country, district, zip, Locale.of(com_locale), _callback);
        };

      callback(<Account
        locale={locale}
        user={user}
        districts={districts}
        sponsor={app.sponsor()}
        message={this.message}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        doUpdateAccount={doUpdateAccount}
        doAcceptCookies={doAcceptCookies}
        loadDistricts={loadDistricts}
        goAccount={goAccount(app)}
        goPurchases={goPurchases(app)}
        goChangePassword={goChangePassword(app)}
        doLogout={doLogout(app)}
        goProduct={goProduct(app)}
        partners={app.partners()} />);
    });
  };
}

class PurchasesRoute {

  constructor() {
    this.name = 'purchases';
  }
  to_widget(app, callback) {
    const goPurchase = (purchase_id) => {
      app.transact(new PurchaseRoute(purchase_id));
    };

    const errorHandler = (err) => {
      if (err) {
        switch (err.name) {
          case 'access denied':
            app.go_expired_session(app.locale);
            break;
          default:
            app.go_unexpected_err(err);
        }
      }
    };

    const successHandler = (purchases) => {
      callback(<Purchases
        locale={app.locale}
        purchases={purchases}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        goPurchase={goPurchase}
        sponsor={app.sponsor()}
        user={app.user}
        doAcceptCookies={doAcceptCookies}
        goAccount={goAccount(app)}
        goPurchases={goPurchases(app)}
        goChangePassword={goChangePassword(app)}
        doLogout={doLogout(app)}
        goProduct={goProduct(app)}
        partners={app.partners()} />);
    };

    app.user.load_purchases(createCallback(successHandler, errorHandler));
  }
}

class PurchaseRoute {

  constructor(purchase_id, message){
    this.name = 'purchase';
    this.purchase_id = purchase_id;
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;
    const purchase_id = this.purchase_id;

    const errorHandler = (err) => {
      if (err) {
        switch (err.name) {
          case 'access denied':
            app.go_expired_session(locale);
            break;
          default:
            app.go_unexpected_err(err);
        }
      }
    };

    const successHandler = (purchase) => {
      Share_Purchase.create(app.share_purchase_url, locale, purchase, function() {
        return true;
      });

      const doSendGiftCardCode = (gift_card_code) => {
        const bundle = get_bundle(locale);
        const cbk = (b) => {
          if (b) {
            const errorHandlerDoSend = (err) => {
              if (err) {
                switch (err.name) {
                  case 'access denied':
                    app.go_expired_session(locale);
                    break;
                  case 'gift card error':
                    app.transact(new PurchaseRoute(purchase_id, <Alert type='error'><MarkdownComponent>{bundle['template_message']['purchase.gift card error']}</MarkdownComponent></Alert>));
                    break;
                  default:
                    app.go_unexpected_err(err);
                }
              }
            };
            const successHandlerDoSend = (res) => {
                app.transact(new PurchaseRoute(res.purchase_id));
            };
            app.user.do_send_gift_card_code(purchase_id, target(app), cancel_target(app, purchase_id), gift_card_code, createCallback(successHandlerDoSend, errorHandlerDoSend));
          } else {
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
          }
        };
        ReactDOM.render(<Confirm callback={cbk} locale={locale} width='600' title={bundle.order.gift_card.confirm_title}><Alert type='warning'><MarkdownComponent>{bundle.order.gift_card.confirm_body}</MarkdownComponent></Alert></Confirm>, document.getElementById('modal-container'));
      };

      callback(<Purchase
          locale={locale}
          message={this.message}
          purchase={purchase}
          themeBgColor={app.getThemeBgColor()}
          themeBtnColor={app.getThemeBtnColor()}
          themeBgFontColor={app.getThemeBgFontColor()}
          themeBtnFontColor={app.getThemeBtnFontColor()}
          user={app.user}
          sponsor={app.sponsor()}
          share_purchase={Share_Purchase.current.html()}
          custom_payments={purchase.custom_payments || []}
          pending_purchase_message={purchase.pending_purchase_message}
          doSendGiftCardCode={doSendGiftCardCode}
          doAcceptCookies={doAcceptCookies}
          goAccount={goAccount(app)}
          goPurchases={goPurchases(app)}
          goChangePassword={goChangePassword(app)}
          doLogout={doLogout(app)}
          goProduct={goProduct(app)}
          partners={app.partners()} />);
    };
    app.user.load_purchase(purchase_id, target(app, purchase_id), cancel_target(app), createCallback(successHandler, errorHandler));
  }
}

class ChangePasswordRoute {
  constructor(message) {
    this.name = 'change_password';
    this.message = message;
  }
  to_widget(app, callback) {
    const locale = app.locale;
    const bundle = get_bundle(locale)['template_message'];

    const doChangePassword = (old_password, new_password) => {
      const errorHandler = (err) => {
        if (err) {
          switch (err.name) {
            case 'access denied':
              app.go_expired_session(locale);
              break;
            case 'invalid old password':
            case 'invalid new password':
              app.transact(new ChangePasswordRoute(<Alert type='error'>{bundle['change_password.' + err.name]}</Alert>));
              break;
            default:
              app.go_unexpected_err(err);
          }
        }
      };
      const successHandler = () => {
        app.transact(new ChangePasswordRoute(<Alert type='success'>{bundle['change_password.done']}</Alert>));
      };
      app.user.do_change_password(old_password, new_password, createCallback(successHandler, errorHandler));
    };

    callback(<ChangePassword
        user={app.user}
        sponsor={app.sponsor()}
        locale={locale}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        message= {this.message}
        doChangePassword={doChangePassword}
        goAccount={goAccount(app)}
        goChangePassword={goChangePassword(app)}
        goPurchases={goPurchases(app)}
        doLogout={doLogout(app)}
        doAcceptCookies={doAcceptCookies}
        goProduct={goProduct(app)}
        partners={app.partners()} />);
  }
}

class BuildOrderRoute {

  constructor(order) {
    this.name = 'build_order';
    this.order = order;
  }

  to_widget(app, callback) {
    Trip.remove();
    const goApproveOrder = (contact, invoice)   => {
      const locale = app.locale;
      const product = app.product;
      const user = app.user;
      let obj = {
        locale: locale,
        domicile: null,
        coupon: null,
        invoice: null
      };

      if (product.is_coupon) {
        obj.coupon = {
          name: contact.coupon_name,
          surname: contact.coupon_surname,
          email: user.email,
          mobile: Verified.is(user) ? user.mobile : contact.mobile,
          mobile_country: Verified.is(user) ? user.country : contact.mobile_country
        };
      }
      else {
        const shipping = jsdk.copy(contact.shipping_id ?
          jsdk.find(product.shippings, contact.shipping_id) :
          product.shippings[0]);

        obj.domicile = {
          name: contact.name,
          surname: contact.surname,
          address: contact.address,
          co: contact.co,
          town: contact.town,
          district: contact.district,
          zip: contact.zip,
          email: user.email,
          mobile: Verified.is(user) ? user.mobile : contact.mobile,
          alt_email: contact.alt_email,
          alt_mobile: contact.alt_mobile,
          shipping: shipping,
          mobile_country: Verified.is(user) ? user.country : contact.mobile_country
        };
      }

      // aggiungo la sezione relativa alla fattura solo se il prodotto
      // lo ammette AND l'utente ha selezionato che desidera la fattura
      if (product.is_invoiced && invoice) {
        obj.invoice = {
          name: invoice.invoice_name,
          vat: invoice.invoice_vat,
          address: invoice.invoice_address,
          town: invoice.invoice_town,
          district: invoice.invoice_district,
          zip: invoice.invoice_zip,
          country: invoice.invoice_country
        };
      }
      const order = Order(obj);
      app.transact(new ApproveOrderRoute(order, null));
    };

    let order = this.order;

    if (!order) {
      order = app.product.is_coupon ? {
        locale: app.locale,
        domicile: null,
        coupon: {
          name: app.user.name,
          surname: app.user.surname,
          email: app.user.email,
          mobile: app.user.mobile,
          mobile_country: app.user.mobile_country
        },
        invoice: null
      } : {
        locale: app.locale,
        domicile: {
          name: app.user.name,
          surname: app.user.surname,
          email: app.user.email,
          mobile: app.user.mobile,
          shipping: app.product.shippings.length === 1 ? app.product.shippings[0] : null
        },
        coupon: null,
        invoice: null
      };
    }

    callback(<BuildOrder
      locale={app.locale}
      product={app.product}
      user={app.user}
      sponsor={app.sponsor()}
      themeBgColor={app.getThemeBgColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      order={order}
      goApproveOrder={goApproveOrder}
      goProduct={goProduct(app)}
      goAccount={goAccount(app)}
      goPurchases={goPurchases(app)}
      goChangePassword={goChangePassword(app)}
      doLogout={doLogout(app)}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  }
}

class ApproveOrderRoute {
  constructor(order, message) {
    this.name = 'approve_order';
    this.order = order;
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;
    const product = app.product;
    const order = this.order;

    const goBuildOrder = () => {
      app.transact(new BuildOrderRoute(order));
    };

    const doApproveOrder = () => {
      const errorHandler = (err) => {
        if (err) {
          switch (err.name) {
            case 'invalid emailAddress':
              modalRequire.Alert.go(locale, 300, "L'indirizzo email non è valido");
              break;
            case 'access denied':
              app.go_expired_session(locale);
              break;
            case 'product sold out':
            case 'out of time':
            case 'invalid price':
            case 'item sold':
            case 'max items reached':
            case 'pending payment':
              product.load_runtime(function(gerr, p) {
                if (gerr) {
                  app.go_unexpected_err(gerr);
                }
                else {
                  app.product = p;
                  app.transact(new ApproveOrderErrorRoute(err));
                }
              }, {
                product_id: app.product.id
              });
              break;
            default:
              app.go_unexpected_err(err);
          }
        }
      };
      const successHandler = (obj) => {
        app.emit('do_approve_order', [product.id]);
        app.product = obj.product;
        app.transact(new PurchaseRoute(obj.purchase_id));
      };
      app.user.do_approve_order(product, order, createCallback(successHandler, errorHandler));
    };

    callback(<ApproveOrder
      locale={locale}
      product={product}
      user={app.user}
      sponsor={app.sponsor()}
      order={order}
      themeBgColor={app.getThemeBgColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      message={this.message}
      goBuildOrder={goBuildOrder}
      doApproveOrder={doApproveOrder}
      goProduct={goProduct(app)}
      goAccount={goAccount(app)}
      goPurchases={goPurchases(app)}
      goChangePassword={goChangePassword(app)}
      doLogout={doLogout(app)}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  }
}

class RequestPinRoute {
  constructor(message) {
    this.name = 'request_pin';
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;
    const doRequestPin = (country, mobile) => {
      const errorHandler = (err) => {
        if (err) {
          switch (err.name) {
            case 'access denied':
              app.go_expired_session(locale);
              break;
            case 'invalid mobile':
            case 'account deleted':
            case 'sms timeout':
              const msg = template(get_bundle(app.locale)['template_message']['request_pin.' + err.name])({
                mobile: countries.format_mobile(country, mobile)
              });
              app.transact(new RequestPinRoute(<Alert type='error'>{msg}</Alert>));
              break;
            default:
              app.go_unexpected_err(err);
          }
        }
      };
      const successHandler = () => {
        app.transact(new InsertPinRoute(country, mobile));
      };
      app.user.do_request_pin(country, mobile, createCallback(successHandler, errorHandler));
    };

    callback(<RequestPin
        locale={locale}
        currency={app.product.currency}
        message={this.message}
        doRequestPin={doRequestPin}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        user={app.user}
        sponsor={app.sponsor()}
        goProduct={goProduct(app)}
        goPurchases={goPurchases(app)}
        goChangePassword={goChangePassword(app)}
        doLogout={doLogout(app)}
        doAcceptCookies={doAcceptCookies}
        partners={app.partners()} />);
  };
}

class ApproveOrderErrorRoute {

  constructor(err){
    this.name = 'approve_order_error';
    this.err = err;
  }

  to_widget(app, callback) {
    const goPurchases = () => {
      app.transact(new PurchasesRoute());
    };

    callback(<ApproveOrderError
      locale={app.locale}
      err={this.err}
      sponsor={app.sponsor()}
      themeBtnColor={app.getThemeBtnColor()}
      goPurchases={goPurchases}
      goCatalog={goCatalog(app)}
      goProduct={goProduct(app)}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  };
}

class ItemSoldRoute {

  constructor() {
    this.name = 'item_sold';
  }

  to_widget(app, callback) {
    if (app.is_widget) {
      callback(<WidgetItemSold
        locale={app.locale}
        sponsor={app.sponsor()}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        product={app.product}
        goProduct={goProduct(app)}
        widget={app.widget()}
        miniSiteURL={app.getMiniSiteURL()} />);
    }
    else {
      callback(<ItemSold
        locale={app.locale}
        sponsor={app.sponsor()}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        product={app.product}
        goProduct={goProduct(app)}
        doShare={doShare(app)}
        doAcceptCookies={doAcceptCookies}
        partners={app.partners()} />);
    }
  }
}

class InsertPinRoute {

  constructor(country, mobile, message) {
    this.name = 'insert_pin';
    this.country = country;
    this.mobile = mobile;
    this.message = message;
  }

  to_widget(app, callback) {
    const locale = app.locale;
    const country = this.country;
    const mobile = this.mobile;
    const doInsertPin = (pin) => {
      const errorHandler = (err) => {
          if (err) {
          switch (err.name) {
            case 'access denied':
              app.go_expired_session(locale);
              break;
            case 'invalid pin':
              const msg = get_bundle(locale)['template_message']['insert_pin.invalid pin'];
              app.transact(new InsertPinRoute(country, mobile, <Alert type='error'><MarkdownComponent>{msg}</MarkdownComponent></Alert>));
              break;
            default:
              app.go_unexpected_err(err);
          }
        }
      };
      const successHandler = () => {
        load_districts(app.lib_url, app.locale.country, function() {
          app.transact(new VerifyRoute());
        });
      };
      app.user.do_insert_pin(pin, createCallback(successHandler, errorHandler));
    };

    callback(<InsertPin
      locale={locale}
      country={country}
      mobile={mobile}
      sponsor={app.sponsor()}
      message={this.message}
      themeBgColor={app.getThemeBgColor()}
      themeBtnColor={app.getThemeBtnColor()}
      themeBgFontColor={app.getThemeBgFontColor()}
      themeBtnFontColor={app.getThemeBtnFontColor()}
      doInsertPin={doInsertPin}
      user={app.user}
      goProduct={goProduct(app)}
      goPurchases={goPurchases(app)}
      goChangePassword={goChangePassword(app)}
      doLogout={doLogout(app)}
      doAcceptCookies={doAcceptCookies}
      partners={app.partners()} />);
  };
}

class VerifyRoute {

  constructor() {
    this.name = 'verify';
  }

  to_widget(app, callback) {
    const locale = app.locale;
    load_districts(app.lib_url, locale.country, function(districts) {
      const loadDistricts = (country, callback) => {
        load_districts(app.lib_url, country, callback);
      };

      const doVerify = (gender, birth_date, country, district, zip) => {
        const errorHandler = (err) => {
          if (err) {
            switch (err.name) {
              case 'access denied':
                app.go_expired_session(locale);
                break;
              default:
                app.go_unexpected_err(err);
            }
          }
        };
        const successHandler = (user) => {
          app.emit('do_verify');
          app.user = user;
          const errorHandlerLoadRuntime = (err) => {
              app.go_unexpected_err(err);
          };
          const successHandlerLoadRuntime = (product) => {
              app.product = product;
              app.transact(Trip.get().next(user, locale));
          };
          app.product.load_runtime(createCallback(successHandlerLoadRuntime, errorHandlerLoadRuntime));
        };
        app.user.do_verify(gender, birth_date, country, district, zip, createCallback(successHandler, errorHandler));
      };
      callback(<Verify
        locale={locale}
        districts={districts}
        country={locale.country}
        sponsor={app.sponsor()}
        themeBgColor={app.getThemeBgColor()}
        themeBtnColor={app.getThemeBtnColor()}
        themeBgFontColor={app.getThemeBgFontColor()}
        themeBtnFontColor={app.getThemeBtnFontColor()}
        loadDistricts={loadDistricts}
        lib_url={app.lib_url}
        doVerify={doVerify}
        user={app.user}
        goProduct={goProduct(app)}
        goPurchases={goPurchases(app)}
        goChangePassword={goChangePassword(app)}
        doLogout={doLogout(app)}
        doAcceptCookies={doAcceptCookies}
        partners={app.partners()} />);
    });
  };
}


class CaptchaRoute {

  constructor(lattice_id, reducer_id) {
    this.name = 'captcha';
    this.lattice_id = lattice_id;
    this.reducer_id = reducer_id;
  }

  to_widget(app, callback) {

    const getCaptchaUrl = () => {
      return app.captcha_url + '/' + this.lattice_id;
    };

    const locale = app.locale;
    const user = app.user;

    if (app.is_widget){
      callback(
        <CaptchaWidgetView
          locale={locale}
          captcha_url={getCaptchaUrl()}
          widget={app.widget()}
        />);
    } else {
      callback(
        <CaptchaView
          locale={locale}
          user={user}
          sponsor={app.sponsor()}
          go_product={goProduct(app)}
          goAccount={goAccount(app)}
          goPurchases={goPurchases(app)}
          goChangePassword={goChangePassword(app)}
          doLogout={doLogout(app)}
          doAcceptCookies={doAcceptCookies}
          partners={app.partners()}
          captcha_url={getCaptchaUrl()}
          themeBtnColor={app.getThemeBtnColor()}
          themeBtnFontColor={app.getThemeBtnFontColor()}
        />);
    }
  }
}



module.exports = App;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/app.js
 **/